import { AHIcon, Box, TouchableBox, useScaleFactor } from "arkh";

import React from "react";
import { Platform, View } from "react-native";

function WidgetAddItemButtonC(props: { onPress: () => void }) {
  const sf = useScaleFactor();
  const s = Math.floor(sf * 90);
  if (Platform.OS === "web") {
    return (
      <TouchableBox
        onPress={props.onPress}
        spaceTop="small"
        style={{
          position: "absolute",
          bottom: 0,

          alignContent: "center",
          flexDirection: "row",
          justifyContent: "center",

          left: 140 * sf,
          right: 140 * sf,
        }}
      >
        <Box
          shadow="medium"
          color="primary"
          style={{
            width: s,
            height: s / 2,

            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",

            borderTopRightRadius: s / 2,
            borderTopLeftRadius: s / 2,
          }}
        >
          <View style={{ paddingBottom: -15 }}>
            <AHIcon color="lightText" type="add" size="xlarge" />
          </View>
        </Box>
      </TouchableBox>
    );
  }
  return (
    <TouchableBox
      onPress={props.onPress}
      spaceTop="small"
      style={{
        position: "absolute",
        bottom: -(s / 2),

        alignContent: "center",
        flexDirection: "row",
        justifyContent: "center",

        left: 140 * sf,
        right: 140 * sf,
      }}
    >
      <Box
        shadow="medium"
        color="primary"
        style={{
          width: s,
          height: s,

          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",

          borderTopRightRadius: s / 2,
          borderTopLeftRadius: s / 2,
        }}
      >
        <View style={{ paddingBottom: s / 2 - 15 }}>
          <AHIcon color="lightText" type="add" size="xlarge" />
        </View>
      </Box>
    </TouchableBox>
  );
}
export const WidgetAddItemButton = React.memo(WidgetAddItemButtonC);
